"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Colorbar: function() {
        return _Colorbar.default;
    },
    IRManager: function() {
        return _IRViewer.IRManager;
    },
    IRViewer: function() {
        return _IRViewer.IRViewer;
    },
    ImageInfoKeys: function() {
        return _enums.ImageInfoKeys;
    },
    MarkerShapesStandard: function() {
        return _enums1.MarkerShapesStandard;
    },
    NotesManager: function() {
        return _utilities.NotesManager;
    },
    ValidSettings: function() {
        return _enums.ValidSettings;
    },
    checkStatusObject: function() {
        return _utilities.checkStatusObject;
    },
    colormap: function() {
        return _utilities.colormap;
    },
    flatMarkerArray: function() {
        return _utilities.flatMarkerArray;
    },
    formatDateTime: function() {
        return _utilities.formatDateTime;
    },
    getBufferFromPath: function() {
        return _utilities.getBufferFromPath;
    },
    getDisplayDelta: function() {
        return _utilities.getDisplayDelta;
    },
    getDisplayTemperature: function() {
        return _utilities.getDisplayTemperature;
    },
    getInfoTable: function() {
        return _utilities.getInfoTable;
    },
    getMarkerById: function() {
        return _utilities.getMarkerById;
    },
    getPaletteScaleMode: function() {
        return _editor.getPaletteScaleMode;
    },
    getStatusCodes: function() {
        return _utilities.getStatusCodes;
    },
    handleImageExport: function() {
        return _utilities.handleImageExport;
    },
    handleImageSave: function() {
        return _utilities.handleImageSave;
    },
    isAutoScaleOn: function() {
        return _editor.isAutoScaleOn;
    },
    temperatureUnits: function() {
        return _enums1.temperatureUnits;
    },
    useColorbar: function() {
        return _useColorbar.default;
    },
    useModel: function() {
        return _ReactModel.default;
    }
});
const _IRViewer = require("./IRViewer");
const _Colorbar = /*#__PURE__*/ _interop_require_default(require("./Colorbar"));
const _useColorbar = /*#__PURE__*/ _interop_require_default(require("./Colorbar/useColorbar"));
const _ReactModel = /*#__PURE__*/ _interop_require_default(require("./IRViewer/Controller/ReactModel"));
const _editor = require("./utilities/editor");
const _utilities = require("./utilities");
const _enums = require("./IRViewer/lib/enums");
const _enums1 = require("./enums");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
